class ColorModeToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    this.button.addEventListener('click', this.toggle.bind(this));
    this.syncPressedState();
    this.updateThemeColor();
  }

  toggle() {
    const isDark = document.documentElement.classList.toggle('dark');
    localStorage.setItem('colorMode', isDark ? 'dark' : 'light');
    this.syncPressedState();
    this.updateThemeColor();
  }

  syncPressedState() {
    const isDark = document.documentElement.classList.contains('dark');
    this.button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    this.button.setAttribute(
      'aria-label',
      isDark ? 'Switch to light mode' : 'Switch to dark mode'
    );

    const sun = this.querySelector('.theme-toggle__icon--sun');
    const moon = this.querySelector('.theme-toggle__icon--moon');
    if (sun) sun.hidden = isDark;
    if (moon) moon.hidden = !isDark;
  }

  updateThemeColor() {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return;
    const isDark = document.documentElement.classList.contains('dark');
    meta.setAttribute('content', isDark ? '#1A1A18' : '#F5F0E8');
  }
}

customElements.define('color-mode-toggle', ColorModeToggle);
